import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverChoiceTable extends Layout {
    labelDetailForOrder: Label;
    sourceDriverChoice: DataSource;
    sourceDriverChoiceSearchPreferences: DataSource;
    tableDriverChoice: Table;
}
